import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLink } from "shared/components/common/base-link";

import type { headerPostMagazineQuery$key } from "scmp-app/queries/__generated__/headerPostMagazineQuery.graphql";

import {
  Container,
  LogoContainer,
  LogoPostMagazine,
  StyledEntityOnelineMenu,
  TagLine,
  TagLineImage,
  TagLineWrapper,
} from "./styles";

export type Props = {
  className?: string;
  reference: headerPostMagazineQuery$key;
};

export const PostMagazineHeader: FunctionComponent<Props> = ({ className, reference }) => {
  const data = useFragment(
    graphql`
      fragment headerPostMagazineQuery on Query {
        postMagSection: section(filter: { entityId: "71" }) {
          subSections {
            items {
              edges {
                ...entityOnelineMenuQueueItemsEdge
              }
            }
          }
        }
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <LogoContainer>
        <BaseLink pathname="/postmag">
          <LogoPostMagazine />
        </BaseLink>
      </LogoContainer>
      <StyledEntityOnelineMenu reference={data.postMagSection.subSections?.items?.edges ?? []} />
      <TagLine>
        <TagLineWrapper>
          <TagLineImage aria-label="Life. Culture. Discovery." role="img" />
        </TagLineWrapper>
      </TagLine>
    </Container>
  );
};

PostMagazineHeader.displayName = "PostMagazineHeader";
